<template>
  <div class="imprint-view">

    <div class="container mt-3">
      <div class="row">
        <div class="col">

          <h1><b>Impressum</b></h1>

          <div style="height: 1rem"></div>
          <p>
            <b>KOPF, HAND + FUSS gemeinnützige Gesellschaft für Bildung mbH</b>
            <br>
            Unsere Büros:<br>
            Hauptsitz: c/o TUECHTIG - Raum für Inklusion,
            Oudenarder Str. 16, 13347 Berlin<br>
            Zweigstelle: Ludwigkirchstr. 2, 10719 Berlin<br>
          </p>

          <p>
            Tel: 030 / 8 321 66 40 Fax: 030 / 8 321 66 41<br>
            E-Mail:
            <a href="mailto:info@kopfhandundfuss.de">
              <u class="text-dark">info[at]kopfhandundfuss.de</u>
            </a>
            <br>
            Internet:
            <a href="https://www.kopfhandundfuss.de">
              <u class="text-dark">https://www.kopfhandundfuss.de</u>
            </a>
          </p>

          <p>Geschäftsführerin: Stefanie Trzecinski</p>

          <p>
            Handelsregister Amtsgericht Berlin (Charlottenburg) HR B 128577 B<br>
            Steuernummer: 27/613/02219<br>
            Inhaltlich Verantwortliche gemäß § 55 Abs. 2 RStV (V.i.S.d.M.):
            Stefanie Trzecinski (Anschrift wie oben)
          </p>

          <h3 style="margin-top: 2em"><b>EU-Disclaimer:</b></h3>
          <p>
            Die Unterstützung der Europäischen Kommission für die Erstellung dieser Veröffentlichung stellt keine
            Billigung des Inhalts dar, welcher nur die Ansichten der Verfasser wiedergibt, und die Kommission kann
            nicht für eine etwaige Verwendung der darin enthaltenen Informationen haftbar gemacht werden.
          </p>

          <br>
          <h3 style="margin-top: 1em"><b>Rechtliche Hinweise</b></h3>
          <p>
            <b>1. Haftungsbeschränkung</b><br>
            Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Die KOPF, HAND + FUSS gGmbH
            übernimmt jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten
            Inhalte. Die Nutzung der Inhalte der Website erfolgt auf eigene Gefahr des Nutzers. Namentlich
            gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und nicht immer die Meinung der
            KOPF, HAND + FUSS gGmbH wieder. Mit der reinen Nutzung der Website der KOPF, HAND + FUSS gGmbH kommt
            keinerlei Vertragsverhältnis zwischen dem Nutzer und der KOPF, HAND + FUSS gGmbH zustande.
          </p>

          <p>
            <b>2. Externe Links</b><br>
            Diese Website enthält Verknüpfungen zu Websites Dritter ("externe Links"). Diese Websites unterliegen der
            Haftung der jeweiligen Betreiber. Die KOPF, HAND + FUSS gGmbH hat bei der erstmaligen Verknüpfung der
            externen Links die fremden Inhalte daraufhin überprüft, ob etwaige Rechtsverstöße bestehen. Zu dem
            Zeitpunkt waren keine Rechtsverstöße ersichtlich. Die KOPF, HAND + FUSS gGmbH hat keinerlei Einfluss auf
            die aktuelle und zukünftige Gestaltung und auf die Inhalte der verknüpften Seiten. Das Setzen von externen
            Links bedeutet nicht, dass sich die KOPF, HAND + FUSS gGmbH die hinter dem Verweis oder Link liegenden
            Inhalte zu Eigen macht. Eine ständige Kontrolle der externen Links ist für die KOPF, HAND + FUSS gGmbH ohne
            konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch
            derartige externe Links unverzüglich gelöscht.
          </p>

          <p>
            <b>3. Urheber- und Leistungsschutzrechte</b><br>
            Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und Leistungsschutzrecht.
            Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung bedarf der vorherigen
            schriftlichen Zustimmung der KOPF, HAND + FUSS gGmbH oder des jeweiligen Rechteinhabers. Dies gilt
            insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe
            von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Rechte Dritter sind
            dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder
            kompletter Seiten ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und Downloads für
            den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt.
          </p>

          <p>Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.</p>

          <p>
            <b>4. Datenschutz</b><br>
            "Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. ("Google"). Google Analytics
            verwendet sog. "Cookies", Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der
            Benutzung der Website durch Sie ermöglicht. Die durch den Cookie erzeugten Informationen über Ihre Benutzung
            diese Website (einschließlich Ihrer IP-Adresse) wird an einen Server von Google in den USA übertragen und
            dort gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um
            Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der
            Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese
            Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte
            diese Daten im Auftrag von Google verarbeiten. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten
            der Google in Verbindung bringen. Sie können die Installation der Cookies durch eine entsprechende
            Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
            gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können. Durch die Nutzung
            dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor
            beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden." Die KOPF, HAND + FUSS gGmbH
            weist ausdrücklich darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
            Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch Dritte geschützt werden kann.
          </p>

          <p>
            Die Verwendung der Kontaktdaten des Impressums zur gewerblichen Werbung ist ausdrücklich nicht erwünscht,
            es sei denn die KOPF, HAND + FUSS gGmbH hatte zuvor seine schriftliche Einwilligung erteilt oder es besteht
            bereits eine Geschäftsbeziehung. Die KOPF, HAND + FUSS gGmbH und alle auf dieser Website genannten Personen
            widersprechen hiermit jeder kommerziellen Verwendung und Weitergabe ihrer Daten.
          </p>

          <p>
            <b>5. Besondere Nutzungsbedingungen</b><br>
            Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten Nummern 1. bis 4.
            abweichen, wird an entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem Falle gelten im
            jeweiligen Einzelfall die besonderen Nutzungsbedingungen.
          </p>

          <p>
            <i>Quelle:</i> Disclaimer von
            <a href="www.Juraforum.de">
              <u class="text-dark">www.Juraforum.de</u>
            </a> - Rechtsportal.
          </p>

          <p style="margin-top: 3em">
            <b>Entwicklung dieser Seite</b><br>
            Diese Seite wird in Kooperation mit dem
            <a href="https://cses.informatik.hu-berlin.de">
              <u class="text-dark">Institut für Didaktik in der Informatik</u>
            </a>
            an der Humboldt-Universität zu Berlin entwickelt.
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imprint-view',
  mounted () {
    window.scroll(0, 0)
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/imprint.vue